//
//                       _oo0oo_
//                      o8888888o
//                      88" . "88
//                      (| -_- |)
//                      0\  =  /0
//                    ___/`---'\___
//                  .' \\|     |// '.
//                 / \\|||  :  |||// \
//                / _||||| -:- |||||- \
//               |   | \\\  -  /// |   |
//               | \_|  ''\---/''  |_/ |
//               \  .-\__  '-'  ___/-. /
//             ___'. .'  /--.--\  `. .'___
//          ."" '<  `.___\_<|>_/___.' >' "".
//         | | :  `- \`.;`\ _ /`;.`/ - ` : | |
//         \  \ `_.   \_ __\ /__ _/   .-` /  /
//     =====`-.____`.___ \_____/___.-`___.-'=====
//                       `=---='
//
//
//     ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//
//               佛祖保佑         永无BUG
//
//
//
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import Cube from 'cube-ui'
import VueZoomer from 'vue-zoomer'
import Meta from 'vue-meta'
import fastclick from 'fastclick'
import VueLazyload from 'vue-lazyload'
import App from './App'
import router from './router'
import store from './store'
// import 'amfe-flexible'

import '@/styles/index.styl' // global css
import '@/fonts/iconfont.css' // iconfont

import LightTimeline from 'vue-light-timeline'

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()

Vue.use(Cube)
Vue.use(VueZoomer)
Vue.use(Meta)
Vue.use(LightTimeline)
fastclick.attach(document.body)

Vue.use(VueLazyload, {
  loading: require('../static/images/common/loading.png')
})

Vue.config.productionTip = false
Vue.config.warnHandler = function () {

}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js